var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc7YearsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5432 8.46452C8.50251 12.9833 4.81865 23.8114 9.22081 32.6189C13.623 41.4263 24.4948 44.9792 33.5355 40.4604C41.0295 36.7148 44.85 28.6218 43.4198 20.9486C43.2324 19.9432 43.8956 18.9762 44.901 18.7888C45.9064 18.6014 46.8734 19.2646 47.0608 20.27C48.7929 29.5632 44.1673 39.287 35.1914 43.7734C24.3775 49.1784 11.2525 44.9678 5.90788 34.2747C0.563233 23.5817 5.07342 10.5567 15.8874 5.15159C24.9056 0.644059 35.517 2.82229 41.9009 9.86468C42.5878 10.6224 42.5304 11.7935 41.7726 12.4804C41.0149 13.1673 39.8438 13.1099 39.1569 12.3522C33.8864 6.53803 25.0728 4.70109 17.5432 8.46452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 24C30 23.3627 30.5084 22.8462 31.1355 22.8462H32.8952V21.1613C32.8952 20.5199 33.4069 20 34.0381 20C34.6693 20 35.181 20.5199 35.181 21.1613V22.8462H36.8645C37.4916 22.8462 38 23.3627 38 24C38 24.6373 37.4916 25.1538 36.8645 25.1538H35.181V26.8387C35.181 27.4801 34.6693 28 34.0381 28C33.4069 28 32.8952 27.4801 32.8952 26.8387V25.1538H31.1355C30.5084 25.1538 30 24.6373 30 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 15H28C26.7778 21.2857 24.8366 27.8571 24.7647 35H20.2353C20.451 29.5714 21.6732 24.1429 22.9673 18.8571H17V15Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc7YearsDark);
export default __webpack_public_path__ + "static/media/ic_7years_dark.c75f944d682a80ea5f28aeb0577f4e43.svg";
export { ForwardRef as ReactComponent };